import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NewsSubCategoryComponent} from './news-subcategory.component';

const routes: Routes = [
    {
        path: 'news-subcategory',
        component: NewsSubCategoryComponent,
        data: {animation: 'news-subcategory'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class NewsSubCategoryRoutingModule {
}
